import { useCallback } from "react";

const YANDEX_METRIKA_ID = 103479471; // замените на свой ID счётчика

export function useMetrika() {
    /**
     * Отправка цели (события)
     * @param {string} targetName - имя цели
     * @param {object} params - дополнительные параметры
     */
    const reachGoal = useCallback((targetName, params = {}) => {
        if (typeof window.ym === "function") {
            window.ym(YANDEX_METRIKA_ID, "reachGoal", targetName, params);
            console.log(`[Metrika] reachGoal: ${targetName}`, params);
        }
    }, []);

    /**
     * Отправка виртуального показа страницы
     * @param {string} url - "виртуальный" URL страницы
     * @param {object} options - дополнительные параметры (title, referer и т.д.)
     */
    const hit = useCallback((url, options = {}) => {
        if (typeof window.ym === "function") {
            window.ym(YANDEX_METRIKA_ID, "hit", url, options);
            console.log(`[Metrika] hit: ${url}`, options);
        }
    }, []);

    return { reachGoal, hit };
}
